<script>
import faq from "./faq.json";
export default {
	data() {
		return {
			baseUrl: window.location.origin,
			questions: faq.sort((a, b) => a.order - b.order)
		};
	},
	methods: {
		navigateToLogin() {
			this.$router.push({ name: "Login" })
		}
	}
}

</script>

<template>
	<section class="main-container" style="">
		<icon type="tffi-icon" name="TFFI-logo" :aria-label="$t('logo')" role="logo" class="main-logo">
			<img class="logo" @click="navigateToLogin" :src="`${baseUrl}/logo.jpg`" alt="Company Logo" style="cursor: pointer">
		</icon>
		<div class="info-container">
			<p>Thank you for signing your agreement/completion certificate. A copy will be emailed to you shortly. Below is some helpful information to ensure a smooth experience.</p>
			<p>At TwentyFirst Financial ("TFFI"), we provide customized, affordable lending solutions that help homeowners & businesses invest in meaningful improvements—whether it's energy efficiency upgrades, home renovations, or other essential projects.</p>
			<b>Need Help?</b>
			<div>
				<div>Dealers:</div>
				<a href="mailto:Dealers@twentyfirstfinancial.com">Dealers@twentyfirstfinancial.com</a>
			</div>
			<br>
			<div>
				<div>Customers:</div>
				<a href="mailto:CSR@twentyfirstfinancial.com">CSR@twentyfirstfinancial.com</a>
				<div>1-800-986-9246</div>
				<p>(M-F, 9am-5pm EST)</p>
				<p>We're committed to providing transparent, reliable lending and are glad to have you as a client. Please don't hesitate to reach out with any questions.</p>
				<div>Sincerely,</div>
				<p>The TwentyFirst Financial Team</p>
			</div>
			<h2>Customer Frequently Asked Questions</h2>
			<div v-for="(item, index) in questions" :key="`landing-page-faq-${index}`">
				<b>{{ index + 1 }}. {{ item.question }}</b>
				<p>{{ item.answer }}</p>
			</div>
		</div>
	</section>
</template>

<style lang="scss" scoped>

.main-container	{
	background: white;
	padding: 2em 4em;
	font-size: 1.5em;

	.info-container {
		padding-top: 2em;
	}

	.logo {
		height: 150px;}

	@media (max-width: 768px) {
		padding: 1em 2em;
		font-size: 1em;

		.info-container {
			padding-top: 1em;
		}

		.logo {
			height: 100px;
		}
	}
}
</style>
